module.exports = __webpack_public_path__ + "static/img/img-about_cg1.917925bf.png";